import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import Image from "../../common/Image";

interface ProductCellProps {
  text: string;
  iconSrc: string;
}

const ProductCell = ({ text, iconSrc }: ProductCellProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ ...theme.customStyles.flexStart, height: "100%", gap: "8px" }}>
      {iconSrc ? (
        <Image src={iconSrc} />
      ) : (
        <Skeleton sx={{ width: "32px" }}></Skeleton>
      )}
      <Typography sx={{ fontWeight: "400" }}>{text}</Typography>
    </Box>
  );
};

export default ProductCell;
